import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { memo, useState } from 'react';
import { MdPictureAsPdf } from 'react-icons/md';
import { PiImageBrokenDuotone } from 'react-icons/pi';

export type TMediaThumbProps = {
  src: string;
  alt: string;
  size: number;
  fallbackColor: string;
  onError?: () => void;
};

export const MediaThumb = memo(({ src, alt, size, fallbackColor, onError }: TMediaThumbProps) => {
  const [errored, setErrored] = useState(false);
  const isPdf = alt.toLowerCase().endsWith('.pdf');

  if (isPdf) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.75,
          background: 'linear-gradient(145deg, #fff5f5 0%, #ffe8e8 100%)',
        }}
      >
        <MdPictureAsPdf size={size * 1.5} color="#e53935" />
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.6rem',
            fontWeight: 700,
            letterSpacing: 1,
            color: '#e53935',
            textTransform: 'uppercase',
            bgcolor: 'rgba(229,57,53,0.12)',
            px: 0.75,
            py: 0.25,
            borderRadius: 0.5,
          }}
        >
          PDF
        </Typography>
      </Box>
    );
  }

  if (errored) {
    return (
      <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <PiImageBrokenDuotone size={size} color={fallbackColor} />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => {
        setErrored(true);
        onError?.();
      }}
      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
    />
  );
});
